import { Coord } from "../types/Interface";
import getCoord from "./getCoord";

export default function generatePoints(centerCoord: Coord, radians: number[], radius: number) {
  return radians.map(angle => getCoord(centerCoord, radius, angle));
}